module.exports = __webpack_public_path__ + "static/media/TechCrunch.4afa978f.png";